import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { useTimer } from '@features/TimeOut'
import { useEffect } from 'react'
import { Heading } from '@ui/Heading'
import { COLORS } from '@assets/styles/colors'
import { IonText } from '@ionic/react'
import { formatTime } from '@shared/helpers/timeFormatting'
import { BlueTransparentButton } from '@shared/styles/BlueTransparentButton'
import { YellowFilledButton } from '@shared/styles/YellowFilledButton'
import { Inline } from '@shared/layout/Inline'
import { useGoToTrainingExercise, WorkoutType } from '@shared/hooks/trainingsNavigation/base'
import { useQueryParam } from '@shared/hooks/useQueryParams'
import { useParams } from 'react-router'
import { ExerciseInWorkout } from '@entities/exercise'
import { workoutExecutionStore } from '@features/workout/execution/workoutExecutionStore'
import { WorkoutHistoryProxy } from '@entities/training'

export const RelaxPage = () => {
	useEffect(() => {
		relaxTime.toggleTimerPlaying(true)
	}, [])
	const workoutType: WorkoutType | undefined = useQueryParam('workout_type') as
		| WorkoutType
		| undefined
	const duration = useQueryParam('duration')
	const { exerciseOrder, trainingID } = useParams<{
		exerciseOrder: string
		trainingID: string
		duration: string
	}>()
	const exercise: ExerciseInWorkout | null =
		workoutExecutionStore.getExerciseByOrder(+exerciseOrder)
	if (!exercise) {
		return
	}

	const goToTrainingExercise = useGoToTrainingExercise()
	const goToNextExercise = () => {
		if (workoutType === 'Training') {
			goToTrainingExercise(+trainingID, +exerciseOrder + 1, workoutType)
		}
	}

	const handleTimerEnd = async () => {
		await WorkoutHistoryProxy.updateTrainingInfo(+trainingID, +exerciseOrder, {
			status: 'completed',
			duration: +(duration || -1),
			rest_time: Math.round((exercise.rest_time || 30) - relaxTime.remainingTime),
		})
		if (workoutExecutionStore.exercisesAmount === +exerciseOrder) {
			await WorkoutHistoryProxy.finishTraining(+trainingID)
		}
		goToNextExercise()
	}

	const relaxTime = useTimer({
		seconds: exercise.rest_time || 30,
		onEnd: handleTimerEnd,
	})

	const onSkip = async () => {
		await handleTimerEnd()
	}

	return (
		<DefaultPage>
			<Content>
				<div className='h-full flex flex-col justify-center items-center'>
					<Heading size={25} weight={600} color={COLORS.DECORATIVE_MEDIUM_BLUE}>
						Прекрасная работа
					</Heading>
					<IonText className='mt-[13px] text-accent-purple text-[14px] font-medium'>
						Осталось еще {workoutExecutionStore.exercisesAmount - +exerciseOrder} из{' '}
						{workoutExecutionStore.exercisesAmount}
					</IonText>
					<Heading className='mt-[101px]' size={25}>
						Отдых
					</Heading>
					<Heading
						size={50}
						weight={800}
						className='mt-[13px]'
						color={COLORS.DECORATIVE_MEDIUM_BLUE}>
						{formatTime(relaxTime.remainingTime)}
					</Heading>
				</div>
			</Content>
			<Inline gap={15}>
				<BlueTransparentButton width={155} onClick={onSkip}>
					Пропустить
				</BlueTransparentButton>
				<YellowFilledButton width={155} onClick={() => relaxTime.addTime(20)}>
					+20 сек
				</YellowFilledButton>
			</Inline>
		</DefaultPage>
	)
}
